import { NullToUndefinedDeep } from "core/types";

export function nullsToUndefined<T>(obj: T): NullToUndefinedDeep<T> {
  if (obj === null) return undefined as unknown as NullToUndefinedDeep<T>;
  if (Array.isArray(obj))
    return obj.map(nullsToUndefined) as unknown as NullToUndefinedDeep<T>;
  if (typeof obj === "object" && obj !== null) {
    return Object.fromEntries(
      Object.entries(obj).map(([k, v]) => [k, nullsToUndefined(v)]),
    ) as NullToUndefinedDeep<T>;
  }
  return obj as NullToUndefinedDeep<T>;
}
